import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import scantrust from './modules/scantrust'
import snackbar from './modules/snackbar'
import utils from './modules/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    scantrust,
    snackbar,
    utils
  }
})
